var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHosHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60.169,
    viewBox: "0 0 60 60.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#cc0028;}.c{fill:#bdab78;}.d{fill:url(#a);}.e{fill:#333;}.f{fill:url(#b);}.g{fill:url(#c);}.h{fill:url(#d);}.i{fill:url(#e);}.j{fill:#eee;}.k{fill:url(#f);}.l{fill:url(#g);}.m{fill:#e2e2e2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.148,
    x2: 0.5,
    y2: 0.749,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.074,
    y1: 0.869,
    x2: 0.96,
    y2: -0.038,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#3c3c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#2c2c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#252523"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0.5,
    cy: 0.5,
    r: 0.452,
    gradientTransform: "translate(-0.127) scale(1.255 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.48,
    y1: 0.681,
    x2: 0.729,
    y2: -0.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.074,
    y1: 0.869,
    x2: 0.96,
    y2: -0.038,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#babbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#cdcccd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#cdcccd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f1f1f1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.869 -91.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.869 91.425)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.753,335.351A18.282,18.282,0,0,1,278.821,344c-.532.2-1.068.365-1.606.51a20.886,20.886,0,0,1-4.264,2.081,20.06,20.06,0,0,0,6.371-1.234,19.686,19.686,0,0,0,11.811-11.809A19.741,19.741,0,0,1,288.753,335.351Z",
    transform: "translate(-238.596 -287.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.176,193.466A16.711,16.711,0,0,1,93.77,180.1a17.169,17.169,0,0,1,.68-2.2,22.686,22.686,0,0,1,1.187-5.077,18.463,18.463,0,0,0,.579,23.08A19.888,19.888,0,0,1,96.176,193.466Z",
    transform: "translate(-91.869 -157.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.94,115.858q1.459.579,2.9,1.186A19.467,19.467,0,0,1,323.232,130.4a19.989,19.989,0,0,1,.592,4.721,19.587,19.587,0,0,1,.6,5.986,21.173,21.173,0,0,0-12.02-25.393q-3.226-1.366-6.533-2.57.62.477,1.208,1Q308.016,114.99,308.94,115.858Z",
    transform: "translate(-265.271 -109.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.835,113.165a23.175,23.175,0,0,0,.249,6.934c.453,2.415.979,4.891,1.567,7.408.063-.6.152-1.205.27-1.809.124-.634.254-1.261.383-1.888q-.429-2.012-.8-3.978a21.5,21.5,0,0,1,13.566-24.1,19.929,19.929,0,0,1,5.492-2.409q.888-.239,1.783-.393a22.871,22.871,0,0,0-22.512,20.233Z",
    transform: "translate(-102.252 -92.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.113,360.562a21.486,21.486,0,0,0,3.794-3.07q1.992-2.029,3.948-4.142-1.641.708-3.293,1.388-.84.876-1.686,1.739a19.472,19.472,0,0,1-13.958,5.9,20.048,20.048,0,0,1-4.909-.615,19.819,19.819,0,0,1-7.023-3.328,20.2,20.2,0,0,1-4.465-2.989,20.438,20.438,0,0,1-1.747-1.74,20.945,20.945,0,0,0,12.88,9.461,21.5,21.5,0,0,0,5.27.661,20.778,20.778,0,0,0,11.189-3.268Z",
    transform: "translate(-131.496 -303.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.739,117.525a19.757,19.757,0,0,0-3.97-7.689,130.874,130.874,0,0,0-10.916-11.573q-.923-.866-1.858-1.712c-.391-.353-.8-.686-1.207-1a19.8,19.8,0,0,0-15.509-3.829q-.894.156-1.784.393A19.8,19.8,0,0,0,119.756,105.2a167.751,167.751,0,0,0-4.52,17.4c-.129.627-.259,1.254-.384,1.888-.118.6-.207,1.207-.27,1.809q-.064.613-.091,1.223a19.917,19.917,0,0,0,.042,2.438,19.574,19.574,0,0,0,4.93,11.52,20.4,20.4,0,0,0,1.747,1.74,20.187,20.187,0,0,0,4.464,2.989,19.559,19.559,0,0,0,8.626,2,20.14,20.14,0,0,0,6.337-1.031c4.208-1.393,8.434-2.958,12.612-4.671q1.653-.677,3.293-1.388c.3-.131.608-.26.911-.392a20.187,20.187,0,0,0,2.885-1.551,19.646,19.646,0,0,0,8.487-12.092,20.264,20.264,0,0,0,.513-3.57A19.588,19.588,0,0,0,168.739,117.525ZM156.876,139.4h0c-5.494,2.4-11.109,4.557-16.693,6.4a18.439,18.439,0,0,1-23.91-21.04,169.053,169.053,0,0,1,4.861-19.126,18.433,18.433,0,0,1,29.894-8.013,129.13,129.13,0,0,1,12.632,13.137,18.411,18.411,0,0,1-6.782,28.636Z",
    transform: "translate(-110.184 -91.425)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.994 109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.403 18.878)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M237.711,283.779a14.926,14.926,0,0,1,1.662-.208,3.05,3.05,0,0,1,3.058,2.991,2.576,2.576,0,0,1-2.077,2.752c-.306.064-2.754.395-3.416.395S237.711,283.779,237.711,283.779Z",
    transform: "translate(-234.802 -283.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M228.053,290.445c-.915-.1-1.826-1.434-1.59-2.957a3.294,3.294,0,0,1,1.861-2.628,3.438,3.438,0,0,1,1.4-.353c.956,0,2.738,1.051,2.045,3.612A3.379,3.379,0,0,1,228.053,290.445Z",
    transform: "translate(-226.424 -284.329)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M208.49,188.478s1.816-2.727,4.014-3.612a14.532,14.532,0,0,1,4.995-.695l-5.645,4.154-2.924.44Z",
    transform: "translate(-208.49 -184.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M238.075,205.079a4.176,4.176,0,0,1,2.3,2.083,3.323,3.323,0,0,1-1.175,4.116c-1.414,1.057-2.857,2.042-2.857,2.042l1.921,3.385-.249-3.207s4.663-2.82,5.2-4.349.122-4.963-3.265-4.969C237.942,204.177,238.075,205.079,238.075,205.079Z",
    transform: "translate(-231.061 -200.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M225.767,197.015a48.422,48.422,0,0,0,4.332-2.65c.835-.714,2.676-2.58,1.236-4.765-2-3.042-5.619.179-6.486,1.249l-1.988-2.764s3.619-4.218,6.753-4.014A6.052,6.052,0,0,1,234.431,187c.357.51,2.855,4.407.357,8.078-1.37,2.013-7.447,5.326-7.447,5.326Z",
    transform: "translate(-220.135 -184.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M208.49,205.572l2.58,2.79,2.134-.338-1.988-2.764Z",
    transform: "translate(-208.49 -201.239)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-186.489 -166.622)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.97 203.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M237.733,283.784a15.278,15.278,0,0,1,1.7-.213,3.12,3.12,0,0,1,3.128,3.059,2.635,2.635,0,0,1-2.124,2.815c-.313.065-2.817.4-3.494.4S237.733,283.784,237.733,283.784Z",
    transform: "translate(-234.758 -283.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M228.09,290.58c-.936-.1-1.868-1.467-1.627-3.024a3.369,3.369,0,0,1,1.9-2.688,3.516,3.516,0,0,1,1.43-.361c.977,0,2.8,1.075,2.092,3.694A3.456,3.456,0,0,1,228.09,290.58Z",
    transform: "translate(-226.424 -284.325)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.49 184.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M208.49,188.576s1.857-2.789,4.105-3.695a14.863,14.863,0,0,1,5.108-.711l-5.773,4.249-2.991.45Z",
    transform: "translate(-208.49 -184.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M238.115,205.1a4.271,4.271,0,0,1,2.356,2.131,3.4,3.4,0,0,1-1.2,4.209c-1.447,1.082-2.922,2.089-2.922,2.089l1.965,3.463-.254-3.28s4.77-2.884,5.317-4.448.124-5.076-3.34-5.083C237.978,204.177,238.115,205.1,238.115,205.1Z",
    transform: "translate(-230.941 -200.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.833,197.31a49.531,49.531,0,0,0,4.431-2.711c.854-.73,2.737-2.639,1.264-4.874-2.05-3.112-5.747.183-6.633,1.277l-2.033-2.827s3.7-4.314,6.907-4.106a6.19,6.19,0,0,1,4.926,3c.365.521,2.92,4.507.365,8.262-1.4,2.059-7.617,5.447-7.617,5.447Z",
    transform: "translate(-220.073 -184.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M208.49,205.579l2.639,2.854,2.183-.345-2.033-2.827Z",
    transform: "translate(-208.49 -201.147)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosHelp);
export default __webpack_public_path__ + "static/media/HOS-Help.151bf7128d82b7efc6841204ef3e45bd.svg";
export { ForwardRef as ReactComponent };